import mapImage from '../../organization/OrgImages/mapimage.svg';
import longUnderline from './ProfilePictureImages/longunderline.svg';

export const LocationSelectionShowcase = () => (
  <div className='flex h-full w-full flex-col bg-gradient-to-t from-secondary-brand-50 from-[23%] to-secondary-brand-25 to-[95%]'>
    <div className='flex flex-col items-start px-6 pt-12 lg:pt-16'>
      <h1 className='m-0 text-display-xs font-bold text-gray-700 lg:text-display-md xl:text-display-lg 2xl:text-display-xl'>
        Make an impact from
        <br />
        anywhere
      </h1>
      <img
        src={longUnderline}
        alt=''
        className='mt-1 h-auto w-[140px] lg:w-[200px] xl:w-[240px] 2xl:w-[280px]'
      />
    </div>
    <img
      src={mapImage}
      alt=''
      className='mt-auto mb-2 block h-auto w-full'
    />
  </div>
);
